import { ReduxHelper } from "helpers";
import {
  ICreateWarehouseRequest,
  IDeleteByIdRequest,
  IUpdateWarehouseRequest,
  IWarehouse,
} from "model";

export const prefix = "WAREHOUSE";

export const createWarehouse = ReduxHelper.generateActions<
  ICreateWarehouseRequest,
  IWarehouse
>(prefix, "CREATE_WAREHOUSE");
export const updateWarehouse = ReduxHelper.generateActions<
  IUpdateWarehouseRequest,
  IWarehouse
>(prefix, "UPDATE_WAREHOUSE");
export const deleteWarehouse = ReduxHelper.generateActions<
  IDeleteByIdRequest,
  { id: string }
>(prefix, "DELETE_WAREHOUSE");
export const clearAction = ReduxHelper.generateLocalAction(
  prefix,
  "CLEAR_ACTION"
);
